import React, { useState } from "react";
import { Card, Modal, Form, Input, Button } from "antd";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
function AdminCalendar() {
  const eventColor = "#d43e01";
  const [modal, setModal] = useState(false);
  const [newEvent, setNewEvent] = useState(null);
  const [form] = Form.useForm();

  const addEvent = () => setModal(!modal);

  const handleCreateEvent = (values) => {
    setNewEvent(values);
    setModal(false);
    form.resetFields();
  };

  const indianFestivals = [
    // 2023
    { title: "Makar Sankranti", start: "2023-01-14", end: "2023-01-14" },
    { title: "Pongal", start: "2023-01-14", end: "2023-01-14" },
    { title: "Republic Day", start: "2023-01-26", end: "2023-01-26" },
    { title: "Holi", start: "2023-03-02", end: "2023-03-02" },
    { title: "Eid al-Fitr", start: "2023-05-01", end: "2023-05-01" },
    { title: "Raksha Bandhan", start: "2023-08-22", end: "2023-08-22" },
    { title: "Independence Day", start: "2023-08-15", end: "2023-08-15" },
    { title: "Ganesh Chaturthi", start: "2023-09-13", end: "2023-09-13" },
    { title: "Dussehra", start: "2023-10-24", end: "2023-10-24" },
    { title: "Diwali", start: "2023-11-12", end: "2023-11-12" },
    { title: "Christmas", start: "2023-12-25", end: "2023-12-25" },

    // 2024
    { title: "Makar Sankranti", start: "2024-01-14", end: "2024-01-14" },
    { title: "Pongal", start: "2024-01-14", end: "2024-01-14" },
    { title: "Republic Day", start: "2024-01-26", end: "2024-01-26" },
    { title: "Holi", start: "2024-03-21", end: "2024-03-21" },
    { title: "Eid al-Fitr", start: "2024-04-20", end: "2024-04-20" },
    { title: "Raksha Bandhan", start: "2024-08-11", end: "2024-08-11" },
    { title: "Independence Day", start: "2024-08-15", end: "2024-08-15" },
    { title: "Ganesh Chaturthi", start: "2024-09-01", end: "2024-09-01" },
    { title: "Dussehra", start: "2024-10-14", end: "2024-10-14" },
    { title: "Diwali", start: "2024-11-02", end: "2024-11-02" },
    { title: "Christmas", start: "2024-12-25", end: "2024-12-25" },
  ];

  return (
    <div>
    <Card>
        <div style={{ height: "480px" }}>
        <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              slotDuration={"00:15:00"}
              handleWindowResize={true}
              editable={true}
              droppable={true}
              selectable={true}
              eventColor={eventColor}
              events={indianFestivals}
              dateClick={addEvent}
            />
        </div>
    </Card>
    <Modal open={modal} onCancel={addEvent} title="Create Event" footer={null}>
          <Form form={form} layout="vertical" onFinish={handleCreateEvent}>
            <Form.Item name="title" label="Title" rules={[{ required: true, message: "Please enter a title" }]}>
              <Input type="text" />
            </Form.Item>
            <Form.Item name="start" label="Start" rules={[{ required: true, message: "Please select a start date" }]}>
              <Input type="date" />
            </Form.Item>
            <Form.Item name="end" label="End" rules={[{ required: true, message: "Please select an end date" }]}>
              <Input type="date" />
            </Form.Item>
            <div className="text-center mt-4">
              <Button type="primary" htmlType="submit">Create</Button>
            </div>
          </Form>
      </Modal>
  </div>
  );
}

export default AdminCalendar;
